import { render, staticRenderFns } from "./AuthenticatorsTable.vue?vue&type=template&id=af42eb56&"
import script from "./AuthenticatorsTable.vue?vue&type=script&lang=js&"
export * from "./AuthenticatorsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticatorsTable.vue?vue&type=style&index=0&id=af42eb56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports